var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.035,
    height: 36,
    viewBox: "0 0 30.035 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_1_",
    "data-name": "user (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M95.7,17.341a8.39,8.39,0,0,0,6.131-2.54,8.389,8.389,0,0,0,2.54-6.131,8.391,8.391,0,0,0-2.54-6.131,8.669,8.669,0,0,0-12.261,0,8.39,8.39,0,0,0-2.54,6.13A8.389,8.389,0,0,0,89.572,14.8,8.392,8.392,0,0,0,95.7,17.341Zm0,0",
    transform: "translate(-80.912)",
    fill: "#67E1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M29.962,257.609a21.417,21.417,0,0,0-.292-2.275,17.922,17.922,0,0,0-.559-2.287,11.3,11.3,0,0,0-.94-2.133,8.049,8.049,0,0,0-1.418-1.848,6.251,6.251,0,0,0-2.037-1.28,7.038,7.038,0,0,0-2.6-.47,2.639,2.639,0,0,0-1.409.6c-.422.275-.917.594-1.468.946a8.411,8.411,0,0,1-1.9.837,7.376,7.376,0,0,1-4.647,0,8.392,8.392,0,0,1-1.9-.837c-.546-.349-1.041-.668-1.469-.947a2.635,2.635,0,0,0-1.409-.6,7.03,7.03,0,0,0-2.6.471,6.246,6.246,0,0,0-2.037,1.28,8.05,8.05,0,0,0-1.417,1.847,11.318,11.318,0,0,0-.94,2.133,17.964,17.964,0,0,0-.559,2.287,21.342,21.342,0,0,0-.292,2.276c-.048.689-.072,1.4-.072,2.126a5.978,5.978,0,0,0,1.775,4.522,6.391,6.391,0,0,0,4.575,1.669H23.684a6.39,6.39,0,0,0,4.575-1.669,5.975,5.975,0,0,0,1.776-4.523c0-.725-.025-1.441-.073-2.126Zm0,0",
    transform: "translate(0 -229.927)",
    fill: "#67E1AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalIco);
export default __webpack_public_path__ + "static/media/personalIco.e333e1324004e673e03018e00355ca40.svg";
export { ForwardRef as ReactComponent };